import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import sourceInformation from '@/pages/sourceInformation'
import vehicleInformation from '@/pages/vehicleInformation'
import customerServiceContact from '@/pages/customerServiceContact'
import evaluationPublicity from '@/pages/evaluationPublicity'
import complaintPublicity from '@/pages/complaintPublicity'
import contactUs from '@/pages/contactUs'
import userGuide from '@/pages/userGuide'
Vue.use(Router)


//meat.type是权限对应的码，没有则为公共页面 0：用户 1：平台 2：财务
export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: register,
    // },
    {
      path: '/',
      name: 'index',
      component: index,
    },
    // 货源信息
    {
      path: '/sourceInformation',
      name: 'sourceInformation',
      component: sourceInformation
    },
    // 车源信息
    {
      path: '/vehicleInformation',
      name: 'vehicleInformation',
      component: vehicleInformation
    },
    // 联系客服
    {
      path: '/customerServiceContact',
      name: 'customerServiceContact',
      component: customerServiceContact
    },
    // 联系我们
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    },
    // 投诉公示
    {
      path: '/evaluationPublicity',
      name: 'evaluationPublicity',
      component: evaluationPublicity
    },
    // 评价公示
    {
      path: '/complaintPublicity',
      name: 'complaintPublicity',
      component: complaintPublicity
    },
    // 用户指南
    {
      path: '/userGuide',
      name: 'userGuide',
      component: userGuide
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js